module.exports = __webpack_public_path__ + "img/gachita_3_1.34768d23.png";